import { render, staticRenderFns } from "./weight_count.vue?vue&type=template&id=c520ef0e"
import script from "./weight_count.vue?vue&type=script&lang=js"
export * from "./weight_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports